export { WidgetConfigProvider, useWidgetConfigContext } from './provider';
export { useWidgetConfigStore } from './store';
export type { WidgetConfigState } from './store';
